/**
 * Use Case: Create E-Wallet Conversion
 * Business logic for creating a new E-Wallet conversion rate.
 */

import type {
  CreateEWalletPayload,
  CreateEWalletResult,
} from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Create a new E-Wallet conversion rate
 */
export const CreateEWalletConversionUseCase = async (
  payload: CreateEWalletPayload
): Promise<CreateEWalletResult> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.createEWalletConversion(payload);
};

